// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","covers":"Loader_covers__Et3TD","up":"Loader_up__UKy3T","loader_dark":"Loader_loader_dark__-xDDV","covers_dark":"Loader_covers_dark__QVdf9"};